module.exports = __webpack_public_path__ + "static/media/Google__G__Logo.686f8efa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Introduction/img/Google__G__Logo.svg
// module id = 135
// module chunks = 0